/** Serialize query params for GET requests (legacy ruoyi tansParams subset). */
export function tansParams(params: Record<string, unknown>): string {
  const parts: string[] = []
  for (const key of Object.keys(params)) {
    const val = params[key]
    if (val === null || val === undefined || val === '') continue
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(val))}`)
  }
  return parts.length ? parts.join('&') + '&' : ''
}

/** 后端 LocalDateTime 要求 yyyy-MM-dd HH:mm:ss */
export function normalizeApiDateTime(value?: string, endOfRange = false): string | undefined {
  if (!value) return undefined
  const trimmed = value.trim()
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(trimmed)) return trimmed
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(trimmed)) {
    if (endOfRange && trimmed.endsWith(' 23:59')) return `${trimmed}:59`
    return `${trimmed}:00`
  }
  return trimmed
}

export function withApiDateParams(params: Record<string, unknown>): Record<string, unknown> {
  const next = { ...params }
  for (const [key, end] of [
    ['startTime', false],
    ['finishTime', true],
    ['beginTime', false],
    ['endTime', true],
  ] as const) {
    if (next[key]) next[key] = normalizeApiDateTime(String(next[key]), end)
  }
  return next
}

export function extractPageList<T>(data: unknown): { list: T[]; total: number } {
  if (Array.isArray(data)) {
    return { list: data as T[], total: data.length }
  }
  if (!data || typeof data !== 'object') return { list: [], total: 0 }
  const d = data as Record<string, unknown>
  const list = (
    Array.isArray(d.list) ? d.list
      : Array.isArray(d.records) ? d.records
        : Array.isArray(d.rows) ? d.rows
          : []
  ) as T[]
  const total = Number(d.totalCount ?? d.total ?? list.length)
  return { list, total }
}
